import React from 'react';
import { Box, Typography, CardContent } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { ChartDataPoint } from './DashboardDeepDiveDropReasons';
import formatMoney from '../../../utils/formatMoney';


/** What Recharts hands a custom tooltip: the hovered point, when there is one. */
interface ChartTooltipProps {
  active?: boolean;
  payload?: { payload: ChartDataPoint }[];
}

const LostRevenueTooltip = ({ active, payload }: ChartTooltipProps) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;

    return (
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '12px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography variant="body2" fontWeight="bold" textAlign="center">
          {data.fullName}
        </Typography>
        <Typography
          variant="body2"
          color="text.primary"
          fontWeight="bold"
          textAlign="center"
        >
          {formatMoney(data.value)}
        </Typography>
      </Box>
    );
  }
  return null;
};

interface LostRevenueChartProps {
  data: ChartDataPoint[];
}

const DashboardLostRevenuePerMemberChart: React.FC<LostRevenueChartProps> = ({
  data,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        mb: 2,
        borderRadius: '8px',
        border: '1px solid rgba(224, 224, 224, 1)',
        backgroundColor: 'white',
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}
        >
          Fatturato Perso per Consulente
        </Typography>
        <ResponsiveContainer width="100%" minWidth={500} height={500}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 50, left: 20, bottom: 50 }}
          >
            <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              angle={60}
              textAnchor="start"
              fontSize={14}
              interval={0}
            />
            <YAxis
              tickFormatter={(value: number) => formatMoney(value)}
            />
            <Tooltip content={<LostRevenueTooltip />} />
            <Bar dataKey="value" fill="#8884d8">
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mt: 1 }}
        >
          Fatturato totale perso nel periodo selezionato
        </Typography>
      </CardContent>
    </Box>
  );
};

export default DashboardLostRevenuePerMemberChart;
